import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

import { SUB_ROUTES } from 'src/components/app/app-routes.constants';

import { ProtectedRouteProps } from './protected-route.model';

export default function ProtectedRoute({
  isAuthenticated,
  authenticationPath,
  redirectPath,
  permissionActions,
  children,
  setRedirectPath,
  action,
  permission,
  ...routeProps
}: ProtectedRouteProps) {
  const currentLocation = useLocation();

  useEffect(() => {
    if (!isAuthenticated) {
      setRedirectPath(currentLocation.pathname);
    }
  }, [isAuthenticated, setRedirectPath, currentLocation]);

  if (isAuthenticated) {
    return (
      <>
        <Outlet {...routeProps} />
        {children}
      </>
    );
  }

  return <Navigate to={{ pathname: SUB_ROUTES.authVerification }} />;
}
